import React, { createContext, useEffect, useState } from 'react';

import {
  WarrOpsCodesContextProvider,
  WarrOpsCodesContext, 
  useWarrOpsCodesContext,
  OpCodesItemType,
  OpCodeCategType,
  opscodesDataType,
  WarrOpsCodesResponseType,
  // warrantyoperationsType,
  WarrOpType,
  WarrOpCategoryType,
  WarrOpCategoriesType
}  from './WarrOpsCodesContext' 

import dayjs from 'dayjs'
import * as isLeapYear from 'dayjs/plugin/isLeapYear'

export interface PrData {
  id: number;
  prcode: string;
  prname: string;
  qty: number;
}

export const laborexample =  {
  id: 2,
  labcode: "0010",
  labenname: "Engine R&R ",
  labseccode: "0010",
  labelname: "Κινητήρας R&R ",
  labqty: 1.0,
  labnotes: "my notes"
};

// export type lbrType = {
//     lbrcode: string,
//     lbrqty: number,
//     lbrenname: string,
//     lbrelname: string,
//     lbrnotes: string     
// } 
// export type prType = {
//     prcode: string,
//     prqty: number
// }

export interface IWarrClaimContextState {
  activeStep: number;
    warrclaimdocid: number;
    warrclaimdoccode: string;
    vin: string;
    warrdate: string;  // dayjs.Dayjs|null;
    faultCode: string;
    faultypegroup: {code:string, name:string};
    causeCode: {code:string, name:string};
    troublegroup: {code:string, name:string};
    trouble: {code:string, name:string};
    reasongroup: {code:string, name:string};
    reason: {code:string, name:string};
    incidentdescr: string;
    labrows: (typeof laborexample)[];
    prrows: PrData[];
    custname: string; //  vchr 128  = custname;
    custaddr: string; //  vchr 100  = address;
    custzip: string;  //  vchr  10  = zip;
    custcity: string; //  vchr 50  = city;
    custcountry: string; //  vchr 50 = country;	
    custmobile: string; //  vchr 30  = mobile;
    custemail: string; //  vchr 80   = email;
    klm: number;
}


export const initialWarrClaimContextState: IWarrClaimContextState={
  activeStep: 0,
    warrclaimdocid: 0,
    warrclaimdoccode: '',
    vin: '',
    warrdate: dayjs(new Date()).toJSON(),
    faultCode: '',
    faultypegroup: {code: '', name: ''},
    causeCode: {code: '', name: ''},
    troublegroup: {code: '', name: ''},
    trouble: {code: '', name: ''},
    reasongroup: {code: '', name: ''},
    reason: {code: '', name: ''},
    incidentdescr:  '',
    labrows: [],
    prrows: [],
    custname: '', //  vchr 128  = custname;
    custaddr: '',  //  vchr 100  = address;
    custzip: '',   //  vchr  10  = zip;
    custcity: '',  //  vchr 50  = city;
    custcountry: 'Ελλάδα',  //  vchr 50 = country;	
    custmobile: '',  //  vchr 30  = mobile;
    custemail: '' , //  vchr 80   = email;
    klm: 0
}

interface WarrClaimContextProps {
  warrClaimState: IWarrClaimContextState;
  setWarrclaimContext: (wclstate : IWarrClaimContextState) => void;
  resetWarrclaimContext: () => void;
  getWarrclaimContext: () => IWarrClaimContextState;
}

export const WarrClaimContext = createContext<WarrClaimContextProps | null>(null);

// const or function
const WarrClaimProvider = ({ children }: { children: React.ReactNode }) => {
    const [warrClaimState, setWarrclaimState] = useState<IWarrClaimContextState>({...initialWarrClaimContextState, warrdate: dayjs(new Date()).toJSON() });
    useEffect(() => {
      console.log("==* WarrClaimProvider, useEffect[] ...")
        const storedState = sessionStorage.getItem(`${process.env.REACT_APP_WARRCLMSESSKEY}`);
        if (storedState) {
          console.log("==* WarrClaimProvider, useEffect[] storedState=",storedState)
          setWarrclaimState(JSON.parse(storedState));
        }
    }, []);

    useEffect(() => {
      console.log("==* WarrClaimProvider, useEffect[warrclaimState] saving warrclaimState=",warrClaimState)
        sessionStorage.setItem(`${process.env.REACT_APP_WARRCLMSESSKEY}`, JSON.stringify(warrClaimState));
    }, [warrClaimState]);

    const resetWarrclaimContext = () => {
        setWarrclaimState({...initialWarrClaimContextState, warrdate: dayjs(new Date()).toJSON() });
    };

    const setWarrclaimContext = (wclstate : IWarrClaimContextState) => {
        console.log("==* WarrClaimProvider, setWarrclaimContext to ",wclstate)
        setWarrclaimState(wclstate);
    };

    function getWarrclaimContext(){
      return warrClaimState
    }

    //  const incrementCounter = () => {
    //     setAppState((prevState) => ({
    //       ...prevState,
    //       counter: prevState.counter + 1,
    //     }));
    //  };

    return (
        <WarrClaimContext.Provider
        value={{ warrClaimState, setWarrclaimContext, resetWarrclaimContext,getWarrclaimContext }}
        >
        {children}
        </WarrClaimContext.Provider>
    );
};

export default WarrClaimProvider;
